import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as OptionIdsVisibleActions from '../option-ids-visible/option-ids-visible.actions';
import { SearchFilterOptionsEntity } from '../option-ids-visible/search-filter-options.models';
import * as SearchResultActions from '../search-results/data-access-search.actions';

export const OPTION_IDS_SELECTABLE_FEATURE_KEY = 'optionIdsSelectable';

export interface OptionIdsSelectableState extends EntityState<SearchFilterOptionsEntity> {
  lastInteractedFilterId?: string;
}
export interface OptionIdsSelectablePartialState {
  readonly [OPTION_IDS_SELECTABLE_FEATURE_KEY]: OptionIdsSelectableState;
}

export function selectOptionsIdSelectable(option: SearchFilterOptionsEntity) {
  return option.key;
}

export const optionIdsSelectableAdapter: EntityAdapter<SearchFilterOptionsEntity> =
  createEntityAdapter<SearchFilterOptionsEntity>({ selectId: selectOptionsIdSelectable });

export const optionIdsSelectableState: OptionIdsSelectableState = optionIdsSelectableAdapter.getInitialState({
  // set initial required properties
});

const reducer = createReducer(
  optionIdsSelectableState,
  on(SearchResultActions.searchResultsLoadSucceeded, (state, { filterOptions }) => {
    let updatedFilterOptions = filterOptions;
    if (state.lastInteractedFilterId) {
      const lastInteractedFilter = state.entities[state.lastInteractedFilterId];
      updatedFilterOptions = filterOptions.map((filterOption) => {
        if (filterOption.key === state.lastInteractedFilterId && lastInteractedFilter) {
          return lastInteractedFilter;
        }
        return filterOption;
      });
    }
    return optionIdsSelectableAdapter.setAll(updatedFilterOptions, { ...state, loaded: true });
  }),
  on(OptionIdsVisibleActions.optionIdsVisibleValuesSelected, (state, { searchFilterOption }) => {
    return { ...state, lastInteractedFilterId: searchFilterOption.key };
  }),
  on(OptionIdsVisibleActions.optionIdsVisibleValuesUnselected, (state, { searchFilterOption }) => {
    return { ...state, lastInteractedFilterId: searchFilterOption.key };
  }),
  on(OptionIdsVisibleActions.clearAllFilters, (state) => {
    return { ...state, lastInteractedFilterId: undefined };
  }),
  on(SearchResultActions.searchFiltersLoadAfterUncheckSucceeded, (state, { filterOptions }) => {
    return optionIdsSelectableAdapter.setAll(filterOptions, { ...state, loaded: true });
  })
);

export function optionIdsSelectableReducer(state: OptionIdsSelectableState | undefined, action: Action) {
  return reducer(state, action);
}
